<template lang="pug">

table.ui.fixed.padded.table(v-show='personModels.length > 0')
    thead
        tr
            th Name
            th Unternehmen
            th E-Mail
    tbody
        tr(
            is="row"
            v-for="person in personModels"
            v-bind:key="person.id"
            v-bind:company-models="companyModels"
            v-bind:person-model="person"
        )

</template>

<script>
    import Row from './table/Row.vue'

    export default {

        components: { Row },

        props: {

            companyModels: {
                type: Array,
                required: true
            },

            personModels: {
                type: Array,
                required: true
            }

        }

    }

</script>
